import {
  grayColor,
  blackColor,
  whiteColor,
  mlAuto,
  hexToRgb
} from "assets/jss/material-kit-pro-react.jsx";

import tooltip from "assets/jss/material-kit-pro-react/tooltipsStyle.jsx";

const headerLinksStyle = theme => ({
  list: {
    [theme.breakpoints.up("md")]: {
      WebkitBoxAlign: "center",
      MsFlexAlign: "center",
      alignItems: "center",
      WebkitBoxOrient: "horizontal",
      WebkitBoxDirection: "normal",
      MsFlexDirection: "row",
      flexDirection: "row"
    },
    [theme.breakpoints.down("sm")]: {
      display: "block"
    },
    marginTop: "0px",
    display: "flex",
    paddingLeft: "0",
    marginBottom: "0",
    listStyle: "none",
    padding: "0"
  },
  listItem: {
    float: "left",
    color: "inherit",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0",
    padding: "0",
    [theme.breakpoints.down("sm")]: {
      "& ul": {
        maxHeight: "400px",
        overflow: "scroll"
      },
      width: "100%",
      "&:not(:last-child)": {
        // "&:after": {
        //   width: "calc(100% - 30px)",
        //   content: '""',
        //   display: "block",
        //   height: "1px",
        //   marginLeft: "15px",
        //   backgroundColor: grayColor[14]
        // }
      }
    }
  },
  listItemText: {
    padding: "0 !important"
  },
  listItemBlock: {
    display: "block"
  },
  navLink: {
    color: "inherit",
    position: "relative",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    "&:hover,&:focus": {
      color: "inherit"
    },
    "& .fab,& .far,& .fal,& .fas,& .material-icons": {
      position: "relative",
      top: "2px",
      marginTop: "-4px",
      marginRight: "4px",
      marginBottom: "0px",
      fontSize: "1.25rem"
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    },
    "& svg": {
      marginRight: "3px",
      width: "20px",
      height: "20px"
    }
  },
  navLinkJustIcon: {
    "& .fab,& .far,& .fal,& .fas,& .material-icons": {
      marginRight: "0px"
    },
    "& svg": {
      marginRight: "0px"
    }
  },
  navButton: {
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "5px",
      marginTop: "5px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start",
        "@media (max-width: 959.95px)": {
          justifyContent: "center",
        }
      }
    },
    "& $icons": {
      marginRight: "3px"
    }
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex"
  },
  registerNavLink: {
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex"
  },
  navLinkActive: {
    "&, &:hover, &:focus,&:active ": {
      color: "inherit",
      backgroundColor: "rgba(" + hexToRgb(whiteColor) + ", 0.1)"
    }
  },
  icons: {
    width: "20px",
    height: "20px",
    marginRight: "14px"
  },
  dropdownIcons: {
    width: "24px",
    height: "24px",
    marginRight: "14px",
    opacity: "0.5",
    marginTop: "-4px",
    top: "1px",
    verticalAlign: "middle",
    fontSize: "24px",
    position: "relative"
  },
  socialIcons: {
    position: "relative",
    fontSize: "1.25rem",
    maxWidth: "24px"
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "flex",
      padding: "0.75rem 1.25rem 0.75rem 0.75rem"
    }
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px"
  },
  collapse: {
    [theme.breakpoints.up("md")]: {
      display: "flex !important",
      MsFlexPreferredSize: "auto",
      flexBasis: "auto"
    },
    WebkitBoxFlex: "1",
    MsFlexPositive: "1",
    flexGrow: "1",
    WebkitBoxAlign: "center",
    MsFlexAlign: "center",
    alignItems: "center"
  },
  borderedList: {
    // "@media (min-width: 959.95px)": {
    //   border: "black 2px solid"
    // }
  },
  RightFloatDiv: {
    float: "right",
    "@media (max-width: 959.95px)": {
      paddingTop: "50px"
    }
  },
  firstLineList: {
    width: "fit-content",
    paddingBottom: "15px"
  },
  fistListItem: {
    "@media (min-width: 959.95px)": {
      paddingRight: "30px",
      display: "inline-flex",
      verticalAlign: "middle"
    },
    "@media (max-width: 959.95px)": {
      marginLeft: "15px"
    },
    "&:after": {
        display: "none !important"
    }
  },
  secondListItem: {
    display: "inline-flex",
    verticalAlign: "middle",
    marginLeft: '0px',
  },
  buttonLink: {
    paddingLeft: '30px !important',
    paddingRight: '30px !important',
    paddingTop: '12px !important',
    paddingBottom: '12px !important',
    backgroundColor: '#FFF'
  },
  phoneIcon: {
    paddingRight: "30px",
    "@media (max-width: 959.95px)": {
      display: "inline-flex",
      verticalAlign: "middle"
    }
  },
  navLinkItem: {
    backgroundColor: "#FFF"
  },
  greenBackground: {
    backgroundColor: "#b6d7a8",
    color: "#000",
  },
  blackBorder: {
    "@media (min-width: 959.95px)": {
      border: "black 2px solid"
    }
  },
  secondListFirstLink: {
    "@media (max-width: 959.95px)": {
      marginTop: "20px"
    }
  },
  secondListLink: {
    color: "#4caf50",
    marginTop: "0px",
    marginBottom: "0px",
    "&:hover,&:focus": {
      color: "#4caf50",
    },
  },
  floatRight: {
    float: 'right',
    "@media (max-width: 960px)": {
      float: 'none'
    }

  },
  horPadding25: {
    paddingLeft: "25px !important",
    paddingRight: "25px !important"
  },
  horPadding23: {
    paddingLeft: "23px !important",
    paddingRight: "23px !important"
  },
  greenColorText: {
    color: "#4caf50"
  },
  whiteColorText: {
    color: whiteColor,
    '&:hover': {
      color: whiteColor
    },
    '&:focus': {
      color: whiteColor
    }
  },
  blackBackground: {
    "@media (max-width: 960px)": {
      backgroundColor: blackColor
    }
  },
  autoWidth: {
    "@media (max-width: 960px)": {
      width: 'auto !important'
    }
  },
  marginTop4px: {
    marginTop: "4px"
  },
  width30px: {
    width: "30px"
  },
  paddingRight16: {
    "@media (min-width: 960px)": {
      paddingRight: "16px"
    }
  },
  marginTopSmall50: {
    "@media (max-width: 992px)": {
      marginTop: "50px"
    }
  },
  margin0Auto: {
    "@media (max-width: 992px)": {
      margin: "0 auto",
      // "&:after": {
      //   width: "calc(100% - 30px)",
      //   content: '""',
      //   display: "block",
      //   height: "1px",
      //   marginLeft: "15px",
      //   backgroundColor: grayColor[14]
      // }
    }
  },
  lineAfter: {
    display: "none",
    "@media (max-width: 960px)": {
      display: "block",
      "&:after": {
        width: "calc(100% - 30px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "15px",
        backgroundColor: grayColor[14]
      },
      paddingTop: "0px",
      paddingBottom: "10px"
    }
  },
  mlAuto
});

export default headerLinksStyle;
